module.exports = __webpack_public_path__ + "img/csrbanner.a5ee1c16.jpg";